import React, { useState, useEffect } from "react";

export default function TopPropertiesDisplay({ 
    properties, 
    filters, 
    onFilterChange, 
    viewMode = "card" 
}) {
    const [backgroundImage, setBackgroundImage] = useState('');
    
    useEffect(() => {
        const getRandomImage = () => {
            let storedImage = localStorage.getItem('backgroundImage');
            if (!storedImage) {
                storedImage = '';
            }

            let randomNumber = Math.floor(Math.random() * 10) + 1;
            while (randomNumber === 0 || randomNumber === -1 || storedImage.endsWith(`${randomNumber}.jpg`)) {
                randomNumber = Math.floor(Math.random() * 10) + 1;
            }

            const imageUrl = `https://kodinyumba.app/media/Stock/hd/Property/apartment${randomNumber}.jpg`;
            setBackgroundImage(imageUrl);
            localStorage.setItem('backgroundImage', imageUrl);
        };

        getRandomImage();
    }, []);

    // Get unique locations for dropdown
    const uniqueLocations = [...new Set(properties?.map(property => property.location))].filter(Boolean);

    const handleSearchChange = (e) => {
        onFilterChange({ search: e.target.value });
    };

    const handleLocationChange = (e) => {
        onFilterChange({ location: e.target.value });
    };

    const handleTypeChange = (e) => {
        onFilterChange({ type: e.target.value });
    };

    // Dynamic labels and options based on view mode
    const searchPlaceholder = viewMode === "card" 
        ? "Search Property" 
        : "Search by House or Tenant";

    const typeLabel = viewMode === "card" ? "All Properties" : "All Units";
    const typeOptions = viewMode === "card" 
        ? [
            { value: "paid", label: "Paid" },
            { value: "partial", label: "Partially Paid" },
            { value: "unpaid", label: "Unpaid" }
          ]
        : [
            { value: "paid", label: "Paid Units" },
            { value: "partial", label: "Partially Paid Units" },
            { value: "unpaid", label: "Unpaid Units" },
            { value: "vacant", label: "Vacant Units" },
            { value: "occupied", label: "Occupied Units" }
          ];

    return (
        <>
            <div className="relative w-full">
                {/* Background Image */}
                <div
                    className="bg-cover bg-center rounded-md w-full h-72 md:h-76 lg:h-80"
                    style={{
                        backgroundImage: `url('${backgroundImage}')`,
                        filter: "brightness(0.85)",
                    }}
                ></div>
                {/* Overlay for darkening */}
                <div className="z-10 absolute inset-0 bg-black/20 w-full h-72 md:h-76 lg:h-80"></div>
                {/* Title */}
                <div className="top-1/2 left-1/2 absolute flex flex-col justify-center items-center w-full"
                    style={{ transform: "translate(-50%, -60%)" }}>
                    <h1 className="drop-shadow-lg font-extrabold text-white text-5xl md:text-7xl text-center tracking-wide"
                        style={{ textShadow: "0 4px 16px rgba(0,0,0,0.5)" }}>
                        {viewMode === "card" ? "MY PROPERTIES" : "MY UNITS"}
                    </h1>
                </div>
                {/* Search/Filter Bar */}
                <div
                    className="bottom-0 left-1/2 absolute flex px-8 w-full"
                    style={{
                        transform: "translate(-50%, 50%)",
                        zIndex: 20,
                        pointerEvents: "none",
                    }}
                >
                    <div
                        className="flex md:flex-row flex-col items-stretch md:items-center gap-3 md:gap-6 space-x-10 bg-white shadow-md -mt-4 px-3 md:px-8 py-4 md:py-6 rounded-sm min-w-full max-w-7xl"
                        style={{ pointerEvents: "auto" }}
                    >
                        {/* Search */}
                        <input
                            type="text"
                            placeholder={searchPlaceholder}
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={filters.search}
                            onChange={handleSearchChange}
                        />
                        {/* Location Dropdown */}
                        <select 
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={filters.location}
                            onChange={handleLocationChange}
                        >
                            <option value="">All Locations</option>
                            {uniqueLocations.map((location, index) => (
                                <option key={index} value={location}>{location}</option>
                            ))}
                        </select>

                        {/* Property/Unit Type Dropdown */}
                        <select 
                            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                            value={filters.type}
                            onChange={handleTypeChange}
                        >
                            <option value="">{typeLabel}</option>
                            {typeOptions.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            {/* Spacer for search bar overlap */}
            <div className="h-24 md:h-16"></div>
        </>
    );
}